export const data = [
  {
    items: [
      {
        id: 1,
        text: "Home",
        link: "/",
      },
      {
        id: 2,
        text: "Blogs",
        link: "/blog",
      },
      {
        id: 3,
        text: "About Us",
        link: "/about-us",
      },
      {
        id: 4,
        text: "Newsletter",
        link: "/contact",
      },
    ],
  },
  {
    items: [
      {
        id: 5,
        text: "Income Tax Act",
        link: "/legal-advice/it-act",
      },

      {
        id: 6,
        text: "Indian Penal Code(IPC)",
        link: "/legal-advice/ipc",
      },

      {
        id: 7,
        text: "Code Of Civil Procedure(CPC)",
        link: "/legal-advice/cpc",
      },

      {
        id: 8,
        text: "Code Of Criminal Procedure(CrPC)",
        link: "/legal-advice/crpc",
      },
    ],
  },
  {
    items: [
      {
        id: 9,
        text: "Apply For Legal Aid",
        link: "/contact",
      },
      {
        id: 10,
        text: "All Blogs",
        link: "/blog",
      },
      {
        id: 11,
        text: "Latest Blogs",
        link: "/blog",
      },
      {
        id: 12,
        text: "Legal Advice",
        link: "/contact",
      },
    ],
  },
  {
    items: [
      {
        id: 13,
        text: "Privacy Policy",
        link: "/privacy-policy",
      },
      {
        id: 14,
        text: "Terms & Conditions",
        link: "/terms-and-conditions/",
      },
      {
        id: 15,
        text: "Cookie Policy",
        link: "/cookie-policy",
      },
    ],
  },
];
